import { StyleRules, Theme } from '@material-ui/core';

export default (theme: Theme): StyleRules => ({
  rememberMe: {
    color: '#8083a0',
  },
  snIcon: {
    '&:first-child': {
      marginLeft: 0,
    },
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      transitionDuration: '300ms',
    },
    '&:last-child': {
      marginRight: 0,
    },
    backgroundColor: '#2D2E41',
    borderRadius: 8,
    height: '40px',
    margin: '0 4px',
    minWidth: '55px',
  },
  socialContainer: {
    marginTop: '12px',
    maxWidth: '100%',
  },
  socialLogos: {
    [theme.breakpoints.up('sm')]: {
      flexWrap: 'nowrap',
      justifyContent: 'flex-end',
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    alignItems: 'center',
  },
  socialTitle: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    display: 'flex',
    justifyContent: 'flex-end',
  },
  typographyForgotPassw: {
    alignSelf: 'center',
  },
  typographySecondary: {
    color: '#8083a0',
    textDecoration: 'none',
  },
});
